<div class="loading-background">
  <app-loading-spinner class="loading"></app-loading-spinner>
</div>